import { DetailFormCheckbox } from 'components/DetailsView/DetailFormCheckbox';

import { cn } from '@/lib/utils';
import { TotemLabel } from '../TotemLabel';

type Item = {
    label: string;
    name: string;
    value: boolean;
};

export const DetailSwitchTable = ({
    label,
    tableName,
    items,
}: {
    label?: string;
    tableName: string;
    items: readonly Item[];
}) => {
    return (
        <div className="inline-flex flex-col gap-[5px]">
            {label ? <TotemLabel>{label}</TotemLabel> : null}
            <div className="min-w-[200px] overflow-hidden rounded-lg border border-border">
                <table className="w-full border-collapse">
                    <tbody>
                        {items.map((item, index) => (
                            <tr key={index} className={cn(index > 0 && 'border-t border-border')}>
                                <td className="px-3 py-2 text-left text-sm font-semibold">{item.label}</td>
                                <td className="px-3 py-2 text-left">
                                    <DetailFormCheckbox
                                        name={`${tableName}.${item.name}`}
                                        defaultChecked={!!item.value}
                                    />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};
